<template>
  <div>
    <div class="add-collection" v-if="show" @click="close()">
      点击“…”添加到我的收藏，<br>
      通过微信-我-收藏即可固定访问
      <icon type="chacha" class="close"></icon>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    mounted () {
      setTimeout(()=>{
        if(!window.localStorage.addCollection&&!this.$route.meta.unCollection) {
          this.show = true
        }
      }, 1000)
    },
    methods: {
      close() {
        this.show = false
        window.localStorage.addCollection = true
      }
    },
  }
</script>

<style lang="less" scoped>
  .add-collection {
    width: 4rem;
    height: 1.3rem;
    background: rgba(255, 255, 255, 1);
    border-radius: .08rem;
    color: #4A4A4A;
    font-size: .24rem;
    padding-left: .3rem;
    padding-top: 0.23rem;
    line-height: 0.4rem;
    position: fixed;
    right: .15rem;
    top: .15rem;
    z-index: 100;
  }

  .add-collection::before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    right: .2rem;
    top: -.2rem;
    border: .1rem solid transparent;
    border-bottom: .1rem solid #fff;
  }
  .close {
    position: absolute;
    right: .25rem;
    top: .25rem;
  }
</style>